module.exports = __webpack_public_path__ + "static/media/execution.a058ffb9.png";